import classNames from 'classnames';
import { Field } from 'react-final-form';
import Select from 'react-select';
import ValidationError from '../ValidationError/ValidationError';
import Chip from '@mui/material/Chip';

import css from './FieldSelectChips.module.css';

const customStyles = {
  control: base => ({
    ...base,
    // border: '1px solid #e0e0e0',
    // boxShadow: 'none',
    // '&:hover': {
    //     border: '1px solid #e0e0e0',
    // },
  }),
  input: base => ({
    ...base,
    boxShadow: 'none',
    outline: 'none',
    caretColor: 'red',
  }),
  // Hide multiValue tags in the select input
  multiValue: base => ({
    ...base,
    display: 'none',
  }),
  valueContainer: base => ({
    ...base,
    padding: '2px 6px',
  }),
  indicatorsContainer: base => ({
    ...base,
    padding: '4px',
  }),
  // Always show the placeholder even if values are selected
  placeholder: base => ({
    ...base,
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#999',
    pointerEvents: 'none',
  }),
  option: base => ({
    ...base,
    backgroundColor: 'white',
    color: 'black',
    '&:hover': {
      backgroundColor: 'var(--Deep-Water, #015672)',
      color: 'white',
    },
  }),
};

const FieldSelectChipsComponent = props => {
  const {
    rootClassName,
    className,
    selectClassName,
    id,
    label,
    input,
    meta,
    onChange,
    disabled = false,
    ...rest
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }

  const { invalid, touched, error } = meta;
  const hasError = touched && invalid && error;

  const selectClasses = classNames({
    [selectClassName]: selectClassName,
    [css.selectError]: hasError,
  });

  // Map react-select value (array of option objects) -> form value (array of string ids)
  const handleChange = value => {
    const next = Array.isArray(value) ? value.map(v => v.value) : [];
    input.onChange(next);
    if (onChange) {
      onChange(next);
    }
  };

  // Remove a chip by filtering out the value and then updating via input.onChange
  const handleDelete = deleteValue => {
    const currentValues = Array.isArray(input.value) ? input.value : [];
    const filtered = currentValues.filter(v => v !== deleteValue);
    input.onChange(filtered);
    if (onChange) {
      onChange(filtered);
    }
  };

  // Prepare select props for react-select
  // Compute selected option objects from string[] in form state
  const allOptions = rest.options || [];
  const selectedValues = Array.isArray(input.value) ? input.value : [];
  const selectedOptions = allOptions.filter(o =>
    selectedValues.includes(o.value)
  );

  const selectProps = {
    className: selectClasses,
    id,
    name: input.name,
    onBlur: input.onBlur,
    onFocus: input.onFocus,
    onChange: handleChange,
    value: selectedOptions,
    ...rest,
  };
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <Select
        {...selectProps}
        styles={customStyles}
        isMulti
        isClearable={false}
        isDisabled={disabled}
        // Hide the selected items in the select using a custom component
        components={{
          MultiValue: props => {
            return <div>{props.data.label},&nbsp;</div>;
          },
        }}
      />
      {/* Render selected values as chips below the select */}
      <div className={css.chipsContainer}>
        {selectedOptions && selectedOptions.length > 0
          ? selectedOptions.map(item => (
            <Chip
              key={item.value}
              label={item.label}
              variant="outlined"
              onDelete={() => handleDelete(item.value)}
              onClick={() => { }}
            />
          ))
          : null}
      </div>
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

const FieldSelectChips = props => {
  return <Field component={FieldSelectChipsComponent} {...props} />;
};

export default FieldSelectChips;
